import { render } from "./SideMenu.vue?vue&type=template&id=30b32e58&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"

import "./SideMenu.vue?vue&type=style&index=0&id=30b32e58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30b32e58"
/* hot reload */
if (module.hot) {
  script.__hmrId = "30b32e58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30b32e58', script)) {
    api.reload('30b32e58', script)
  }
  
  module.hot.accept("./SideMenu.vue?vue&type=template&id=30b32e58&scoped=true", () => {
    api.rerender('30b32e58', render)
  })

}

script.__file = "src/views/support/modules/SideMenu.vue"

export default script